import {
    useEffect,
    type FC
} from "react";
import type IStickerProps from "./type";
import {
    getBadgePropsFromSticker
} from "./util";
import {
    warnOnce
} from "../../utils/development";
import Badge from "../badge";

const Sticker: FC<IStickerProps> = (props) => {
    const badgeProps = getBadgePropsFromSticker({
        props
    });

    useEffect(() => {
        warnOnce({
            message: "Sticker is deprecated and will be removed in the next major version. Use Badge instead."
        });
    }, []);

    useEffect(() => {
        if(props.iconPosition !== "left" && props.iconPosition !== "right") {
            return;
        }

        warnOnce({
            message: "Sticker: \"iconPosition\" values \"left\" and \"right\" are deprecated and will be removed in the next major version. Use \"start\" or \"end\" instead."
        });
    }, [
        props.iconPosition
    ]);

    return <Badge
        {...badgeProps}
    />;
};
export default Sticker;
